
























import Vue from 'vue';
export default Vue.extend({
  name: 'FullscreenContent',
  props: {
    heading: {
      type: String,
      default: '',
    },
    contentCallout: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    closeText: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
  },
});
